import type { RouteRecordRaw } from 'vue-router'

// Routes of the shop area. meta.account: requires a signed-in account.
// The catalog and product pages are public; purchase asks for a login at the point of buying.
export const routes: RouteRecordRaw[] = [
  { path: '/shop', name: 'shop', component: () => import('./IndexView.vue') },
  { path: '/shop/products/:code', name: 'shop-product', component: () => import('./ProductView.vue'), props: true },
  { path: '/shop/library', name: 'shop-library', component: () => import('./LibraryView.vue'), meta: { account: true } },
  { path: '/shop/orders/:orderId', name: 'shop-order', component: () => import('./OrderView.vue'), meta: { account: true }, props: true },
  { path: '/shop/exam/:paperId', name: 'shop-exam', component: () => import('./ExamView.vue'), meta: { account: true }, props: true },
  { path: '/shop/exam/attempts/:attemptId', name: 'shop-attempt', component: () => import('./ExamView.vue'), meta: { account: true }, props: true },
  { path: '/shop/practice/:paperId', name: 'shop-practice', component: () => import('./PracticeView.vue'), meta: { account: true }, props: true },
]
